import {ChangeDetectorRef, Component, Input, OnDestroy} from '@angular/core';
import {CommandsService} from '@app/app/shared/services/commands.service';
import {Subscription} from 'rxjs/Subscription';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';

@Component({
  selector: 'park-backwash',
  templateUrl: './park-backwash.component.html',
})

export class ParkBackwashComponent implements OnDestroy {
  @Input() public backwashMode: string;
  @Input() public parkId: any;
  @Input() public id: any;

  public isRunningOn: boolean;
  public isRunningOff: boolean;

  private timerSub: Subscription;

  private MODE_ON = 'on';
  private MODE_OFF = 'off';
  private MODE_STOPPING = 'stopping';

  constructor(private comm: CommandsService, private cdRef: ChangeDetectorRef) {
    //
  }

  /**
   * Set mode to auto
   */
  public setModeOn() {
    // Do not send command if another one is running
    if (!this.isRunning()) {
      this.isRunningOn = true;
      this.update(this.MODE_ON);
    }
  }

  /**
   * Set mode to off
   */
  public setModeOff() {
    // Do not send command if another one is running
    if (!this.isRunning()) {
      this.isRunningOff = true;
      this.update(this.MODE_OFF);
    }
  }

  public isOn() {
    const isOn = (this.backwashMode === this.MODE_ON) ;

    if (isOn && this.isRunningOn) {
      this.isRunningOn = false;
      this.cdRef.detectChanges();
    }

    return isOn;
  }

  public isOff() {
    const isOff = (this.backwashMode === this.MODE_OFF) ;

    if (isOff && this.isRunningOff) {
      this.isRunningOff = false;
      this.cdRef.detectChanges();
    }

    return isOff;
  }

  public isStopping() {
    return (this.backwashMode === this.MODE_STOPPING);
  }

  public isRunning() {
    return (this.isRunningOn || this.isRunningOff);
  }

  /**
   * Update activator
   */
  private update(mode: string) {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }

    this.comm.setBackwashMode(this.parkId, this.id, mode).then((res) => {
      this.timerSub = Observable.of(true).delay(15000).subscribe(() => {
        if (this.isRunningOn && this.backwashMode !== this.MODE_ON) {
          alert('Timed Out');
        }

        if (this.isRunningOff && this.backwashMode !== this.MODE_OFF) {
          alert('Timed Out');
        }

        this.isRunningOn = false;
        this.isRunningOff = false;
      });
    }).catch((err) => {
      this.isRunningOn = false;
      this.isRunningOff = false;

      alert(err);
    });
  }

  ngOnDestroy() {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/backwash/park-backwash.component.ts